import { PersistentCartPaymentOptions as Treatment } from "./ExperimentLegalAgreements/PersistentCartPaymentOptions";
import { PersistentCartPaymentOptions as Control } from "./PersistentCartPaymentOptions";
import type { PersistentCartPaymentOptionsProps as ControlProps } from "./PersistentCartPaymentOptions";
import type { PersistentCartPaymentOptionsProps as TreatmentProps } from "./ExperimentLegalAgreements/PersistentCartPaymentOptions";

export const PersistentCartPaymentOptions = (
  props: ControlProps | TreatmentProps,
) => {
  if (props.legalAgreementsExperimentEnabled) {
    return <Treatment {...props} />;
  }
  return <Control {...props} />;
};
